import React, { useState } from 'react';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import './SimpleFeedbackUI.css'

const SimpleFeedbackUI = (props: SbarUIConfig) => {
	return (
		<div id="SimpleFeedbackUI" style={{
			width: '100%',
			height: '100%',
			position: 'absolute',
			top: '0',
			left: '0',
			pointerEvents: 'all',
			zIndex: 1000
		}} className="modal-bg fade-in-animation modal-disable-select">
			<div style={{
				width: '590px',
				position: 'absolute',
				left: '50%',
				top: '50%',
				transform: 'translate(-50%, -50%)'
			}}>
				<img src="./assets/images/general/components/sbar/window_sbar_v2.png"/>
				<div style={{
					position: 'absolute',
					top: '30px',
					left: '50%',
					width: '570px',
					height: '253px',
					transform: 'translate(-50%, 0)',
					overflow: 'auto'
				}} aria-label='feedback'>
					<p tabIndex={0} id='first-object-feedbackUi' className="title-font" style={{
						position: 'absolute',
						top: '50%',
						left: '0',
						margin: '0',
						transform: 'translate(0, -50%)',
						fontWeight: 'normal',
						fontSize: '16pt',
						textAlign: 'center',
						color: 'white',
						width: '100%'
					}}>{props.text}</p>
				</div>
				
				<GeneralButtonWithText parameters= {{
					srcIdle: './assets/images/general/components/sbar/button_sbar_submit_main.png',
					srcHighlight: './assets/images/general/components/sbar/button_sbar_submit_down.png',
					id: 'last-object-feedbackUi',
					highlightOnHover: true,
					text: 'Continue',
					top: '290px',
					left: '230px',
					width: '137.33px',
					customImgStyle: {
						maxWidth: 'unset',
						width: '100%',
						height: '100%'
					},
					customTextStyle: {
						fontSize: '14pt'
					},
					onClicked: () => {
						var el = document.getElementById('SimpleFeedbackUI');
						el.classList.remove('fade-in-animation');
						el.classList.add('fade-out-animation');
						setTimeout(() => {
							if(props.onClose) {
								props.onClose();
							}
						}, 500);
					}
				}}/>
			</div>
		</div>
	)
};

export interface SbarUIConfig {
	text: string;
	onClose: () => void;
}

export default SimpleFeedbackUI;